import React, { useState, useEffect, useContext } from 'react';
import ThemeContext from '../context/theme.Context';
import NotificationContext from '../context/notification.Context';
import UserDetailsContext from '../context/userDetails.context';
import LoadingContext from '../context/loading.context';
import LocationsContext from '../context/locations.Context';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from './Spinner.component';
import * as Constants from '../modules/constants';


const AddDevice = function (props) {

    const { showMessage } = useContext(NotificationContext);
    const { showLoading, hideLoading } = useContext(LoadingContext);
    const { token } = useContext(UserDetailsContext);
    const { activeLocationId } = useContext(LocationsContext);

    const [unassignedDevices, setUnassignedDevices] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [addedDeviceCount, setAddedDeviceCount] = useState(0);

    const apiHostName = Constants.API_URL;

    useEffect(() => {

        // Get unassigned devices:
        setButtonDisabled(true);
        showLoading();
        fetch(apiHostName + '/v1/devices/unassigned', {
            mode: "cors",
            method: 'GET', headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Invalid network response");
                }
                return response.json();
            })
            .then((result) => {
                // Result contains (a.o.) list of devices - update them now:
                result.map(device => {
                    device.selected = false;
                    device.visible = true;
                    return device;
                });
                setUnassignedDevices(result);
                hideLoading();
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Getting unassigned devices failed...");
                console.error(error);
                hideLoading();
                showMessage({ newMessage: 'Network error' });
            });

        return () => {
            // Do nothing
        };
    }, [apiHostName, showLoading, hideLoading, showMessage, token]);


    function toggleCheckbox(e) {
        // update the unassignedDevices array to set the "selected" property to true or false for the selected device:
        var selectedCount = 0;
        unassignedDevices.map(device =>
            device.id.toString() === e.target.name ? device.selected = e.target.checked : null
        );
        // If 0 devices are selected, disable the add button, otherwise enable the add button:
        unassignedDevices.map(device => device.selected === true ? selectedCount++ : null);
        if (selectedCount > 0)
            setButtonDisabled(false);
        else
            setButtonDisabled(true);

    }

    function AddDeviceToLocation(deviceId) {
        setButtonDisabled(true);
        showLoading();
        fetch(apiHostName + '/v1/devices/' + deviceId + '/associate-location?locationId=' + activeLocationId, {
            mode: "cors",
            method: 'PUT', headers: { "Authorization": "Bearer " + token }
        })
            .then(function (response) {
                if (!response.ok) {
                    return response.text();
                }
                return new Promise(function (resolve, reject) { resolve("OK") });
            })
            .then((result) => {
                // Result contains a text message that the action was successful - ignore this...
                if (result !== "OK") {
                    showMessage({ newMessage: "Error: " + result });
                    hideLoading();
                }
                else {
                    // Ok... Update data...
                    const updatedDevices = [];
                    unassignedDevices.map(device => {
                        if (device.id === deviceId) {
                            const updatedDevice = { ...device };
                            updatedDevice.visible = false;
                            updateUnassignedDevice(updatedDevice);
                            return updatedDevice;
                        }
                        else {
                            updatedDevices.push(device);
                            if (device.visible)
                                setButtonDisabled(false);   // Still 1 or more devices to add...
                            return device;
                        }
                    });
                    hideLoading();
                    setAddedDeviceCount(prevState => prevState + 1);
                }
            })
            .catch(function (error) {
                // Set visual cue and error text to be displayed on login screen
                console.error("Cannot associate device to location...");
                console.error(error);
                showMessage({ newMessage: 'Network error' });
                hideLoading();
            });

    }

    function updateUnassignedDevice(device) {
        setUnassignedDevices(prevState => {
            const newDevices = [];

            prevState.map(orgDev => {
                if (orgDev.id === device.id) {
                    newDevices.push(device);
                    return device;
                }
                else {
                    newDevices.push(orgDev);
                    return orgDev;
                }
            });
            return newDevices;
        });
    }

    function getDeviceDescription(deviceId, deviceType, description) {
        if (description)
            return description + ' (' + deviceType + ' (' + deviceId + '))';
        return deviceType + ' (' + deviceId + ')';
    }

    function handleSubmit(event) {
        event.preventDefault();

        setButtonDisabled(true);
        setAddedDeviceCount(0);

        // Post the selected devices to the server:
        unassignedDevices.map(device =>
            device.visible && device.selected === true ? AddDeviceToLocation(device.id) : null
        );

    }


    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Card bg={themeContext.theme} text={themeContext.textColor}>
                    <Card.Body>
                        <Card.Title>
                            Add new device
                        </Card.Title>
                        <Card.Text as="div">
                            {!unassignedDevices || unassignedDevices.length === 0 ?
                                <div>There are no unassigned devices you can add. Please add your new device to the WiFi network first, and make sure you are connected to the same network.</div>
                                :
                                <Form onSubmit={(event) => { handleSubmit(event); }}>
                                    Select the device(s) you want to add to your location:
                                    {unassignedDevices.map(device =>
                                        device.visible && <Form.Check label={getDeviceDescription(device.id, device.deviceType, device.description)} key={device.id} name={device.id} onChange={(e) => { toggleCheckbox(e); }} />
                                    )}
                                    <Form.Group>
                                        <Button variant='secondary' disabled={buttonDisabled} type="submit">Add device(s)<Spinner /></Button>
                                    </Form.Group>

                                </Form>
                            }
                            {addedDeviceCount > 0 &&
                                <div>Added {addedDeviceCount} device(s).</div>
                            }
                        </Card.Text>

                    </Card.Body>

                </Card>
            )}
        </ThemeContext.Consumer>
    );
}

export default AddDevice;


// WEBPACK FOOTER //
// ./src/components/AddDevice.js